var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDialPad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "dial-pad",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 2a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm7 0a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm7 6a3 3 0 1 0-3-3 3 3 0 0 0 3 3zM5 9a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm7 0a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm7 0a3 3 0 1 0 3 3 3 3 0 0 0-3-3zM5 16a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm7 0a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm7 0a3 3 0 1 0 3 3 3 3 0 0 0-3-3z",
    "data-name": "keypad"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialPad);
export default __webpack_public_path__ + "static/media/dial-pad.6a007d857796f36b6e2f187462bd23fe.svg";
export { ForwardRef as ReactComponent };